if (!customElements.get('gift-with-purchase-countdown')) {
  customElements.define(
    'gift-with-purchase-countdown',
    class GiftWithPurchaseCountdown extends HTMLElement {
      constructor() {
        super();
        this.interval = null;
        this.expireTime = null;
      }

      connectedCallback() {
        const expireData = this.dataset.expire;
        if (!expireData) return;

        this.expireTime = this.parseExpireTime(expireData);
        if (!this.expireTime) return;

        const now = new Date();
        if (this.expireTime <= now) {
          this.onExpired();
          return;
        }

        this.startCountdown();
      }

      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }

      parseExpireTime(dateString) {
        const match = dateString.match(/^(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
        
        if (!match) {
          console.error('Invalid date format. Expected YYYY/MM/DD HH:mm:ss');
          return null;
        }

        const [, year, month, day, hour, minute, second] = match;

        const date = new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hour),
          parseInt(minute),
          parseInt(second)
        );

        return date;
      }

      startCountdown() {
        this.updateCountdown();
        
        this.interval = setInterval(() => {
          this.updateCountdown();
        }, 1000);
      }

      updateCountdown() {
        const now = new Date();
        const timeDiff = this.expireTime - now;

        if (timeDiff <= 0) {
          this.onExpired();
          return;
        }

        const timeUnits = this.calculateTimeUnits(timeDiff);
        this.updateDisplay(timeUnits);
      }

      calculateTimeUnits(milliseconds) {
        const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
        const hours = Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

        return { days, hours, minutes, seconds };
      }

      updateDisplay(timeUnits) {
        const formatNumber = (num) => num.toString().padStart(2, '0');

        const daysElement = this.querySelector('[js-countdown-banner="days"]');
        const hoursElement = this.querySelector('[js-countdown-banner="hours"]');
        const minutesElement = this.querySelector('[js-countdown-banner="minutes"]');
        const secondsElement = this.querySelector('[js-countdown-banner="seconds"]');

        if (daysElement) daysElement.textContent = formatNumber(timeUnits.days);
        if (hoursElement) hoursElement.textContent = formatNumber(timeUnits.hours);
        if (minutesElement) minutesElement.textContent = formatNumber(timeUnits.minutes);
        if (secondsElement) secondsElement.textContent = formatNumber(timeUnits.seconds);
      }

      onExpired() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }

        this.updateDisplay({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        this.setAttribute('aria-hidden', 'true');
      }
    }
  );
}